import { Language } from "../languages/labels/language.labels"

export function taxPeriodCompanyList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'monthly', display: lang.labels.monthly },
    { code: 'quarterly', display: lang.labels.quarterly },
    { code: 'semiannual', display: lang.labels.semiannual },
    { code: 'annual', display: lang.labels.annual },
  ]
}

export function taxPeriodMethodCompanyList(lang: Language, tax_method: string): {code: string, display: string}[] {
  switch (tax_method) {
    case 'effective':
      return [
        { code: 'quarterly', display: lang.labels.quarterly },
        { code: 'monthly', display: lang.labels.monthly },
        { code: 'annual', display: lang.labels.annual },
      ]
    case 'tdfn':
      return [
        { code: 'semiannual', display: lang.labels.semiannual },
        { code: 'annual', display: lang.labels.annual },
      ]
    case 'taf':
      return [
        { code: 'semiannual', display: lang.labels.semiannual },
        { code: 'annual', display: lang.labels.annual },
      ]
    default:
      return []
  }
}

/** Default periodicity for a given tax method */
export function defaultPeriodicityForMethod(tax_method: string): string {
  switch (tax_method) {
    case 'tdfn':
    case 'taf':
      return 'semiannual';
    case 'effective':
      return 'quarterly';
    default:
      return '';
  }
}

/** Allowed periodicities per tax method (no lang dependency) */
export function allowedPeriodicitiesForMethod(tax_method: string): string[] {
  switch (tax_method) {
    case 'effective':
      return ['quarterly', 'monthly', 'annual'];
    case 'tdfn':
    case 'taf':
      return ['semiannual', 'annual'];
    default:
      return [];
  }
}

export function taxPeriodCompanyValue(lang: Language, code: string): string {
  let qrTemplate = taxPeriodCompanyList(lang).find((item) => (item.code === code))
  return qrTemplate ? qrTemplate.display : lang.labels.undefined
}
